import AvailabilityCriterionItem from './AvailabilityCriterionItem/AvailabilityCriterionItem'
import AvailabilityCriterionItemSkeleton from './AvailabilityCriterionItemSkeleton/AvailabilityCriterionItemSkeleton'
import EmptyMessage from './EmptyMessage/EmptyMessage'
import SortableList from './SortableList/SortableList'
import SortableWrapper from './SortableWrapper/SortableWrapper'
import * as Styles from './styles'

const AvailabilityCriterionItemList = ({
  criteria,
  loading,
  onEdit,
  onDuplicate,
  onDelete,
  dragging,
  onSortStart,
  onSortEnd,
}) => {
  if (loading) return <AvailabilityCriterionItemSkeleton />
  if (!criteria?.length) return <EmptyMessage />

  return (
    <SortableList items={criteria} onSortEnd={onSortEnd} onSortStart={onSortStart}>
      <Styles.Container>
        {criteria?.map((criterion, index) => (
          <SortableWrapper key={criterion.id} id={criterion.id} dragging={dragging}>
            <AvailabilityCriterionItem
              criterion={criterion}
              index={index}
              onEdit={onEdit}
              onDuplicate={onDuplicate}
              onDelete={onDelete}
            />
          </SortableWrapper>
        ))}
      </Styles.Container>
    </SortableList>
  )
}

export default AvailabilityCriterionItemList
